import http from '../../utils/http';

/**
 * 提交反馈（含图片）
 * @param {string} content - 反馈内容
 * @param {File[]} files - 图片文件列表
 */
export const createFeedback = (content, files) => {
  const formData = new FormData();
  formData.append('Content', content);

  if (files && files.length > 0) {
    files.forEach((file) => {
      formData.append('images', file);
    });
  }

  return http.post('/api/Feedback/Create', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
